import { jsxs as v, jsx as a } from "react/jsx-runtime";
import { cardHeaderVariants as i } from "./CardHeader.variants.js";
const N = i.definition().defaultVariants, u = ({
  as: d = "div",
  children: n,
  className: t,
  noBorder: c = !1,
  size: o = N.size,
  slotEnd: e,
  slotStart: s,
  ...l
}) => {
  const { root: m, content: f, slot: r } = i;
  return /* @__PURE__ */ v(d, { className: m({ noBorder: c, size: o, className: t }), ...l, children: [
    s && /* @__PURE__ */ a("div", { className: r(), children: s }),
    /* @__PURE__ */ a("div", { className: f(), children: n }),
    e && /* @__PURE__ */ a("div", { className: r(), children: e })
  ] });
};
export {
  u as CardHeader
};
